import { render, staticRenderFns } from "./GeneralConfiguration.vue?vue&type=template&id=3c8e0368&scoped=true"
import script from "./GeneralConfiguration.vue?vue&type=script&lang=js"
export * from "./GeneralConfiguration.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfiguration.vue?vue&type=style&index=0&id=3c8e0368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e0368",
  null
  
)

export default component.exports